import type { IconPropsType } from "./types";

import { IIconWrapper } from "./styles";

import Sprite from "../../assets/media/icons/sprites/arrows-icon-sprite.svg";

export type ServiceIconComponentPropsType = IconPropsType<{
  variant: "tail" | "filter" | "select";
  name: "to-top-right" | "double" | "once" | "arrow";
}>;

export const ArrowsIcon: CT<ServiceIconComponentPropsType> = ({
  variant,
  wrapper,
  className,
  style,
  height = 24,
  width = 24,
  name = "to-top-right",
}) => {
  return (
    <IIconWrapper
      style={{
        width: wrapper ? wrapper.width : "auto",
        height: wrapper ? wrapper.height : "auto",
        ...(wrapper?.style ?? ""),
      }}
    >
      <svg
        className={className}
        style={{ width: width, height: height, ...style }}
      >
        <use href={`${Sprite}#${name}-${variant}-icon`} />
      </svg>
    </IIconWrapper>
  );
};
